import React from 'react';
import { Link } from 'react-router-dom';

import url from 'data-url:../../images/logo.png';

import styles from './index.css';

export function DeereLogo({ className, style, bars, component: Component }) {
    Component = Component || Link;

    return (
        <div className={`${styles.root} ${className}`} style={style}>
            {bars && (
                <div className={styles.bars}>
                    <div className={styles.green}></div>
                    <div className={styles.yellow}></div>
                </div>
            )}
            <Component className={styles.link} to="/">
                <img className={styles.image} src={url} />
            </Component>
        </div>
    );
}
